module.exports = __webpack_public_path__ + "static/img/platform-icon-3.f443f7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/platform-icon-3.png
// module id = wPBE
// module chunks = 0